'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var interfaces = require('./util/interfaces.js');
var user_constants = require('./util/user.constants.js');
var normalize = require('./util/normalize.js');
var date = require('./util/date.js');
var staticContent = require('./util/static-content.js');
var magic = require('./magic.js');



Object.defineProperty(exports, 'CtaStyle', {
	enumerable: true,
	get: function () {
		return interfaces.CtaStyle;
	}
});
Object.defineProperty(exports, 'CtaTarget', {
	enumerable: true,
	get: function () {
		return interfaces.CtaTarget;
	}
});
exports.REALITY_CHECK_DISABLED_VALUE = user_constants.REALITY_CHECK_DISABLED_VALUE;
exports.normalize = normalize.normalize;
exports.chunkDateRange = date.chunkDateRange;
exports.formatDate = date.formatDate;
exports.getPageContent = staticContent.getPageContent;
exports.magic = magic.magic;
